import styled, { css } from 'styled-components';
import ICONS from '../../constants/icons';

// Summary block

export const SummaryBlockContainer = styled.div`
  width: Calc((100% - 40px) / 3);
  height: 120px;
  background: #ffffff;
  padding: 32px 46px 32px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${(props) => props.theme.laptopL`
  padding: 24px 46px 24px 24px;
  height: 100px;
  `}
`;

export const SummaryBlockIcon = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 12px;
  background-image: url(${({ icon }) => icon});
  background-size: contain;
  background-position: center;
`;

export const SummaryBlockMain = styled.div`
  flex-grow: 1;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SummaryBlockTitle = styled.div`
  font-family: Roboto-m;
  line-height: 24px;
  color: #373333;
`;

export const SummaryStats = styled.div`
  display: flex;
  font-family: Roboto-r;
  font-size: 1.2rem;
  color: #05000066;
  line-height: 24px;
  align-items: center;
`;

export const SummaryStatsChange = styled.div`
  padding: 0 18px 0 0;
  font-family: Space-r;
  font-size: 1.4rem;
  line-height: 2.4rem;
  color: #050000cc;
  background-image: url(${ICONS.ArrowUpGreen});
  background-position: right center;
  background-repeat: no-repeat;
  background-size: auto 50%;
  background-repeat: no-repeat;
  margin-right: 6px;
`;

export const SummaryStatsValue = styled.div`
  font-family: Space-r;
  font-size: 4rem;
  line-height: 6.2rem;
  color: #373333;
`;

// program requests

export const ProgramRequestsContainer = styled.div`
  width: 100%;
  background: #ffffff;
`;

export const ProgramRequestsHeader = styled.div`
  width: 100%;
  height: 64px;
  padding: 20px 24px 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Roboto-m;
  line-height: 24px;
  color: #373333;
`;

export const ProgramRequestsSeeAll = styled.div`
  font-family: Gotham-r;
  font-size: 1.4rem;
  line-height: 24px;
  color: #05000099;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const ProgramRequestsNavBar = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  border-top: 1px solid #0500001f;
  border-bottom: 1px solid #0500001f;
  overflow-x: auto;
`;

export const ProgramRequestsNavItem = styled.div`
  flex-grow: 1;
  /* min-width: 20%; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  color: ${({ active }) => (active ? '#050000' : '#05000099')};
  background: ${({ active }) => (active ? '#ffffff' : '#fafafa')};
  position: relative;
  border-right: 1px solid #0500001f;
  text-align: center;
  text-transform: capitalize;
  &:last-child {
    border-right: none;
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    border-radius: 1px;
    background: ${({ theme }) => theme.color.primary};
    top: -2px;
    display: ${({ active }) => (active ? 'block' : 'none')};
  }
  cursor: pointer;
`;

export const ProgramRequestsList = styled.div`
  width: 100%;
  padding: 4px 24px;

  @media (max-width: 600px) {
    padding: 0;
  }
`;

// program request row

export const ProgramRequestsRowContainer = styled.div`
  width: 100%;
  height: 44px;
  margin: 18px 0 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-right: 2px solid
    ${({ theme, status }) =>
      status === 'APPROVED'
        ? theme.color.primary
        : status === 'PENDING'
        ? '#FFCC00'
        : theme.color.error};
  padding-right: 14px;
  cursor: pointer;
`;

export const ProgramRequestsRowPrimaryText = styled.span`
  font-family: Roboto-r;
  line-height: 24px;
  color: #050000cc;
  text-transform: capitalize;
`;

export const ProgramRequestsRowSecondaryText = styled.span`
  font-family: ${({ num }) => (num ? 'Space-r' : 'Roboto-r')};
  font-size: 1.2rem;
  line-height: 16px;
  color: #05000066;
`;

export const PlaceholderContainer = styled.div`
  width: 100%;
  height: 44px;
  margin: 18px 0 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-right: 14px;
  padding-top: 90px;
  padding-bottom: 90px;
`;

export const PlaceholderText = styled.span`
  color: #050000;
  font-family: Space-r;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
`;

export const PlaceholderIcon = styled.img`
  margin-bottom: 24px;
`;

export const WorkoutTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const WorkoutTh = styled.th`
  text-align: left;
  color: #050000;
  font-family: Roboto-m;
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 2.4rem;
  padding: 3.1rem 0 1.8rem 0;
  &:last-child {
    text-align: right;
  }
`;

export const ThText = styled.span`
  opacity: 0.4;
`;

export const ThIcon = styled.div`
  display: inline-block;
  background-image: url(${ICONS.TableSortSvg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 1.2rem;
  width: 1rem;
  margin-left: 4px;
  cursor: pointer;
`;

export const WorkoutTd = styled.td`
  border-top: 0.5px solid rgba(5, 0, 0, 0.12);
  text-align: left;
  padding: 1.9rem 0;
`;

export const TdText = styled.span`
  color: #373333;
  font-family: Roboto-r;
  font-size: 1.6rem;
  letter-spacing: 0;
  line-height: 2.1rem;
`;

const iconByStatus = ({ status }) => {
  switch (status) {
    case 'Done':
      return ICONS.StatusDone;
    case 'Missed':
      return ICONS.StatusMissed;
    default:
      return ICONS.StatusNew;
  }
};

export const StatusIcon = styled.div`
  display: inline-block;
  background-image: url(${iconByStatus});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 1.1rem;

  @media (max-width: 600px) {
    width: 18px;
    height: 18px;
    margin-right: 26px;
  }
`;

export const HC = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify};
`;

export const AttachmentsCount = styled.span`
  color: #373333;
  font-family: 'Space-r';
  font-size: 1.6rem;
  letter-spacing: 0;
  line-height: 2.4rem;
  text-align: center;
`;

export const AttachmentIcon = styled.div`
  display: inline-block;
  background-image: url(${ICONS.AttachmentSvg});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 1.6rem;
  width: 0.7rem;
  margin-left: 4px;
  margin-right: 1.6rem;
`;

export const TabContainer = styled.div`
  background-color: ${({ active }) => (active ? 'white' : 'rgba(0, 255, 145, 0.07)')};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: ${({ active }) => (active ? 'white' : 'rgba(0, 255, 145, 0.035)')};
  }

  @media (max-width: 600px) {
    background-color: rgba(0, 255, 145, 0.2);
    /* background-color: ${({ active }) => (active ? 'white' : 'rgba(0, 255, 145, 0.2)')}; */
    flex: ${({ active }) => (active ? 1 : 0)};
  }
`;

export const ActiveBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #00ff91;

  @media (max-width: 600px) {
    background-color: transparent;
  }
`;

export const TabName = styled.span`
  opacity: 0.6;
  color: #050000;
  font-family: Roboto-r;
  font-size: 1.2rem;
  letter-spacing: 0;
  line-height: 1.8rem;
  margin-top: 1.2rem;

  @media (max-width: 600px) {
    opacity: 0.5;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.5px;
    margin-top: 16px;
  }
`;

export const TabValue = styled.span`
  color: #050000;
  font-family: 'Space-r';
  font-size: 2rem;
  letter-spacing: 0;
  line-height: 3rem;
  text-align: center;
  opacity: ${({ active }) => (active ? 1 : 0.8)};
  margin-top: 0.8rem;

  @media (max-width: 600px) {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    margin-top: 0;
  }
`;

export const Avatar = styled.div`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  color: transparent;
  font-family: 'Gotham-r';
  font-size: 0.8rem;
  letter-spacing: 0;
  line-height: 1rem;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-shrink: 0;
  margin-right: 1.4rem;
  border-radius: 5px;

  ${({ src }) =>
    !src &&
    css`
      background-color: #f1f0f0;
      color: #373333;
      user-select: none;
    `}
`;

export const EmptyText = styled.span`
  font-family: Space-r;
  font-size: 2rem;
  line-height: 2.8rem;
  margin: 4.8rem auto;
  text-align: center;
`;

export const WorkoutInfoWrapper = styled.div`
  padding: 24px 20px;
  width: 100%;
  border-bottom: 1px solid rgba(5, 0, 0, 0.12);
`;

export const TraineeInfoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TraineeName = styled.div`
  font-family: Roboto-r;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: #373333;
  margin-right: auto;
`;

export const WorkoutNameWrapper = styled.div`
  font-family: Roboto-r;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: left;
  color: #373333;
  display: flex;
  margin-top: 12px;
  align-items: center;
`;

export const DumbellIcon = styled.img`
  margin-right: 20px;
  height: 24px;
`;

// Mobile Workout Page
export const WorkoutPageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  background: #f1f0f0;
  position: fixed;
  z-index: 13;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const WorkoutPageHeader = styled.div`
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #00000024;
  background: #fff;
  margin-bottom: 52px;
`;
export const WorkoutPageBackArrow = styled.div`
  width: 24px;
  height: 24px;
  background-image: url(${ICONS.ArrowLeft});
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 16px;
`;
export const WorkoutPageAvatar = styled.div`
  width: 72px;
  height: 72px;
  padding: 6px;
  margin-right: 0;
  border: ${({ theme }) => `1px solid ${theme.color.primary}`};
  position: absolute;
  z-index: 14;
  border-radius: 50%;
  top: 24px;
  background: #fff;
`;

export const WorkoutPageImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const WorkoutPageTraineeName = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-family: Roboto-b;
`;

export const WorkoutPageName = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-family: Space-r;
`;

export const WorkoutPageContent = styled.div`
  height: 100%;
  width: 100%;
  padding: 24px 16px 14px;
  height: fit-content;
`;

export const WorkoutPageMessage = styled.div`
  width: 100%;
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 3px rgba(74, 74, 74, 0.12);
  margin-bottom: 10px;
`;

export const WorkoutPageMessageHeader = styled.div`
  width: 100%;
  border-radius: 4px 4px 0 0;
  padding: 12px 20px;
  border-bottom: 1px solid #4a4a4a22;
  font-family: Roboto-m;
  font-size: 14px;
  color: #050000cc;
  display: flex;
  align-items: center;
  text-transform: uppercase;
`;

export const WorkoutPageMessageIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(${ICONS.RespMessage});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;
  margin-right: 16px;
  position: relative;
  &::after {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.color.primary};
    border-radius: 50%;
    top: -1px;
    right: -1px;
  }
`;

export const WorkoutPageMessageText = styled.div`
  width: 100%;
  border-radius: 0 0 4px 4px;
  padding: 12px 20px;
  font-family: Roboto-r;
  font-size: 14px;
  line-height: 22px;
  color: #373333cc;
  font-style: italic;
`;
